// The motion choice (A7U5), the theme's twin: localStorage keeps it for the first paint and the server keeps it for the
// next device. `data-reduced-motion` on <html> answers it in app.css.
export const REDUCED_MOTION_KEY = 'orca.reducedMotion'

function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function keep(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    // Not kept: the choice lasts until the tab closes.
  }
}

export const readReducedMotion = () => read(REDUCED_MOTION_KEY) === 'true'

export function saveReducedMotion(on: boolean) {
  keep(REDUCED_MOTION_KEY, on ? 'true' : null)
}

export function applyReducedMotion(on: boolean) {
  const root = document.documentElement
  if (on) root.dataset.reducedMotion = 'true'
  else delete root.dataset.reducedMotion
}

/** Pins what is kept on <html> before the first render. */
export function applyKeptAppearance() {
  applyReducedMotion(readReducedMotion())
}
